import React from "react";
import { Link } from 'react-router-dom';
import TextInput from "~/shared/form/TextInput";
import ControlledForm from "~/shared/form/ControlledForm";
import FormResponse from "~/shared/form/FormResponse";
import FormButton from "~/shared/form/FormButton";
import FormSection from "~/shared/form/FormSection";
import PublicPage from "./PublicPage";

export default function PublicContactUs() {
    return (
        <PublicPage title="Family Portal" documentTitle="Contact Us" heading="Contact Us">
            <ControlledForm post="contact" onSubmit={data => data.name = `${data.firstName} ${data.lastName}`} success="Successfully sent message." resetOnSuccess>
                <p className="text-neutral-600 mb-4">
                    Need help or have a question? Reach out via email at&nbsp;
                    <a href="mailto:info@nextgenerationfocus.org" className="red-link">info@nextgenerationfocus.org</a>,
                    or use the form below.
                </p>
                <div className="flex flex-col gap-4">
                    <FormSection row wrap gap={1}>
                        <TextInput label="First Name" id="firstName" required />
                        <TextInput label="Last Name" id="lastName" required />
                    </FormSection>
                    <TextInput label="Your Email" id="email" errorLabel="email" preset="email" required />
                    <TextInput label="Phone Number" id="phone" preset="phone" required />
                    <TextInput label="Subject" id="subject" required />
                    <TextInput label="Message" id="message" multiline rows={4} required />
                </div>
                <FormResponse className="mt-4" />
                <div className="flex flex-col gap-4 items-center mt-6">
                    <FormButton submit>Send Message</FormButton>
                    <Link to="/family-portal" className="red-link">Return to Login</Link>
                </div>
            </ControlledForm>
        </PublicPage>
    );
}
